module.exports = __webpack_public_path__ + "static/img/bgInfo.ec9b143f.png";